/* eslint-disable @typescript-eslint/no-unused-vars */
import { IDictionary } from "@/core/@types/types";
import {
  compact,
  flattenDeep,
  intersection,
  type List,
  merge,
  clone,
  isEqual
} from "lodash";
import type { IF360Utility } from "./types";
import { injectable } from "inversify";
import "reflect-metadata";
@injectable()
export class F360Lodash implements IF360Utility {
  objectIsEqual<T>(data: T, compare: T): boolean {
    return isEqual(data, compare);
  }

  //@arao
  // eslint-disable-next-line unused-imports/no-unused-vars
  groupBy<T>(collection: T[], by: (value: T) => T): IDictionary<T[]> {
    throw new Error("Method not implemented.");
  }

  clone<T>(data: T): T {
    return clone(data);
  }

  mergeObjects<T>(target: T, sources: T): T {
    return merge(target, sources);
  }

  removeFalsy(array: Array<unknown>) {
    return compact(array);
  }

  flattenDeep(array: Array<unknown>) {
    return flattenDeep(array);
  }

  intersection(...arrays: List<unknown>[]): unknown[] {
    return intersection(...arrays);
  }
}
